/**
 * Brand configuration — §3.8 + §6 compliance.
 *
 * Everything resolves from config.brandSkin. Components import from here,
 * never hardcode brand names, logo paths, or skin-specific values.
 *
 * To rebrand: set VITE_BRAND_SKIN=monarch at build time. Zero component changes.
 */

import { config } from './config';

const skin = config.brandSkin;  // 'orbital' | 'monarch'

/** Display name for the product — bare name in-app per §3.8 */
export const PRODUCT_NAME = config.appName;  // "Passport"

/** Brand word — "Orbital" or "Monarch" for marketing/entry surfaces */
export const BRAND_WORD = config.brandWord;

/** Branded product name — for login/entry screens where context is needed */
export const BRANDED_NAME = `${BRAND_WORD} ${PRODUCT_NAME}`;

// ── Asset paths — resolved from /brand/<skin>/ ──────────────────────────

/** Mark — crown/ellipse, transparent bg, for dark chrome */
export const LOGO_MARK = `/brand/${skin}/mark.svg`;
export const LOGO_MARK_DARK = `/brand/${skin}/mark.svg`;
export const LOGO_MARK_LIGHT = `/brand/${skin}/mark.svg`;

/** Full-color mark (monarch: teal/gold crown; orbital: TBD) */
export const LOGO_MARK_FULL = `/brand/${skin}/mark-full.svg`;

/** Wordmark — text only, white, transparent bg */
export const LOGO_WORDMARK = `/brand/${skin}/wordmark.svg`;

/** Whether to show mark + wordmark side by side (true) or a combined lockup file (false) */
export const USE_COMPOSED_LOCKUP = true;

/** Favicon */
export const FAVICON = `/brand/${skin}/favicon.svg`;

/** Touch icon */
export const TOUCH_ICON = `/brand/${skin}/png/touch-icon-128.png`;

/** Alt text for logos */
export const LOGO_ALT = PRODUCT_NAME;

/** TOTP issuer name (shown in authenticator apps) */
export const TOTP_ISSUER = skin === 'monarch' ? 'Monarch Passport' : PRODUCT_NAME;

/** Footer tagline */
export const FOOTER_TEXT = `${PRODUCT_NAME} — Centralized Identity Management`;

/** Whether to show theme toggle (dark-only under monarch) */
export const SHOW_THEME_TOGGLE = skin !== 'monarch';
